<template>
  <div class="container-steps">
    <div class="row">
      <div
        v-for="(step, index) of steps"
        :key="index"
        :class="`${![0,3].includes(index) ? 'border-right-steps' : '' } border-bottom-step col-4 text-center`"
      >
        <img class="icons mb-2" :src="step.icon" alt=""><br>
        <span class="font-size-step" v-html="step.title"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['steps']
}
</script>

<style scoped>
.container-steps {
  background-color: var(--color-primary);
  width: 100%;
  font-family: var(--font-baloo-regular);
  padding: 30px;
  color: white;
}
.border-right-steps {
  border-left: 2px solid #fff;
}
.font-size-step {
  font-size: 22px;
}
.icons {
  width: 35%;
}
@media only screen and (min-width: 2080px) and (max-width: 3000px) {
  .font-size-step {
    font-size: 30px;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1264px) {
  .font-size-step {
    font-size: 18px;
  }
  .icons {
    width: 40%;
  }
}
@media (max-width: 768px) {
  .font-size-step {
    font-size: 15px;
  }
  .icons {
    width: 50%;
  }
  .container-steps {
    margin-top: 10px
  }
}
@media (max-width: 499px) {
  .icons {
    width: 85%;
  }
  .container-steps {
    padding: 10px;
    margin-top: 20px
  }
}
@media only screen and (min-width: 360px) and (max-width: 420px) {
  .icons {
    width: 100%;
  }
}
@media (max-width: 320px) {
  .icons {
    width: 100%;
  }
  .container-steps {
    padding: 8px;
  }
}
</style>
